import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import * as warning from '../../../actions/alert.warning.actions';
import * as actions from '../../../actions/alert.actions';

import Content from './Content';
import Warning from '../../labels/LabelWarning';
import Error from '../../dialogs/Error';

// eslint-disable-next-line
import style from './_styles.css';

class Index extends React.Component {
    constructor(props) {
        super(props);
        props.loadAlert(this.props.session.user);
    }

    state = {};

    handleClick = () => {
        this.props.setWarningReaded(false);
    };

    handleBack = () => {
        /*
        let path = this.props.history.location.pathname.split('/');
        path.splice(path.length - 1, 1);
        path = path.join('/');
        this.props.history.push(path);
        */
        if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }
    };

    static getDerivedStateFromProps(props, state) {
        const { info, alert, alertTabs, alerts } = props;
        if (
            info !== state.info ||
            alert !== state.alert ||
            alertTabs !== state.alertTabs ||
            alerts !== state.alerts
        ) {
            state.info = info;
            state.alert = alert;
            state.alertTabs = alertTabs;
            state.alerts = alerts;
            return state;
        }
        return null;
    }

    render() {
        const { info, alert, alertTabs, alerts } = this.state;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '57')&&
              info.security.licencias.some((f) => f.id === 150 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            const alertdiv = alert && alertTabs === 2 && (
                <Warning
                    text="alert_tab_checked_warning"
                    button="alert_tab_checked_button"
                    onClick={this.handleClick}
                />
            );
            return (
                <div id="alerts" className="alerts width100 bg_ice_blue">
                    <Content alerts={alerts} session={this.props.session} />
                    {alertdiv}
                </div>
            );
        }
    }
}

Index.propTypes = {
    alert: PropTypes.bool.isRequired,
    alertTabs: PropTypes.number.isRequired,
    alerts: PropTypes.array.isRequired,
    alert_is_loading: PropTypes.bool.isRequired,
    alert_is_saving: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
    return {
        info: state.info,
        alert: state.alert,
        alertTabs: state.alertTabs,
        alerts: state.alerts,
        alert_is_loading: state.alert_is_loading,
        alert_is_saving: state.alert_is_saving,
        session: state.session,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, warning), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Index));



// WEBPACK FOOTER //
// ./src/components/complex/alerts/Index.js